/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import FormikInput from 'src/components/formik/FormikInput';
import FormikSelect from 'src/components/formik/FormikSelect';
import { CC_TYPES_LIST, FUEL_TYPES_LIST } from '../ProductConstants';
import CompanyDropDown from 'src/business-components/CompanyDropDown';

function VehicleForm({ values }) {
    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Vehicle Details</h5>
                <div className="form-row">
                <div className="form-group col-md-3">
                            <label>Manufacturer/Company</label>
                            <CompanyDropDown 
                                name="manufacturer"  
                                className="form-control"
                                value={values.manufacturer}
                            />
                        </div>
                    <div className="form-group ml-1">
                        <label>Segment</label>
                        <FormikInput
                            name="meta.segment"
                            type="text"
                            className="form-control"
                        />
                    </div>

                    <div className="form-group ml-1">
                        <label>Cubic Capacity (CC)</label>
                        <FormikSelect
                            items={CC_TYPES_LIST}
                            name="meta.cubicCapacity"
                            className="form-control"
                        />
                    </div>

                    <div className="form-group ml-1">
                        <label>Sitting Capacity (seats)</label>
                        <FormikInput
                            name="meta.sittingCapacity"
                            type="number"
                            className="form-control"
                            min="1"
                        />
                    </div>

                    <div className="form-group ml-1">
                        <label>Fuel Type</label>
                        <FormikSelect
                            name="meta.fuelType"
                            items={FUEL_TYPES_LIST}
                            className="form-control"
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}

export default VehicleForm;
